import styled from 'styled-components';
import { DefaultParagraphLargeFactory, DefaultTitleMediumFactory, DefaultTitleSmallFactory } from '../../../../../../components/Habitacional/core/Typograph/Typograph.Style';

export const ContainerCompleteFormDFI = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: "1 0 0",
}))

export const ContainerTextCompleteFormDFI = styled.div(() => ({
    display: "flex",
    marginTop: "32px",
    alignSelf: "stretch",
}))

export const ContentNumberCompleteFormDFI = styled.div(() => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: "32px",
    alignSelf: "stretch",
}))

export const TitleNumberCompleteFormDFI = styled.h4(({theme}) => ({
    ...DefaultTitleMediumFactory({theme})
}))

export const DescriptionDataCompleteFormDFI = styled.p(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme})
}))

export const NumberCompleteFormDFI = styled.h4(({theme}) => ({
    color: theme.color.brandSecondary.medium,
    fontSize: '28px',
    fontWeight: 500,
    marginBotton: '12px',
    lineHeight: '150%',
    
    [theme.breakpoint.lg()]: {
        fontSize: '40px'
    }
}))

export const Content = styled.div(() => ({
    display: "block",
    gap: "32px",
    marginTop: "32px",
}))

export const TextWithIcon = styled.div(({theme}) => ({
    display: "flex",
    gap: "16px",
    alignItems: "center",

    [theme.breakpoint.md()]: {
        gap: "44px",
    }
}));

export const icon = styled.div(() => ({
    alignItems: "center",
    display: "flex",
}))

export const MainText = styled.p(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme}),
    textAlign: "left",
}));

export const ContentButton = styled.div(() => ({
    display: "grid",
    gap: "24px",
    marginTop: "32px",
}))

export const ContentLink = styled.div(() => ({
    display: "grid",
    gap: "16px",
    marginTop: "32px",
}))

export const TextWithButton = styled.p(({theme}) => ({
    ...DefaultTitleSmallFactory({theme})
}))

export const TextLink = styled.a(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme}),
    color: theme.color.brandPrimary.light,
    textDecoration: "underline",
    display: "flex",
    alignItems: "center",
    gap: "8px"
}))